/* eslint-disable */
import { useCallback, useEffect, useMemo, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { Filter } from 'lucide-react';
import analyticsAction from '../../../Actions/analytics.actions';
import { filtersInfoChip } from '../../../Helpers';
import styles from './CookingHistory.module.scss';
import CookingAnalysisListPage from './CookingAnalysisListPage';
import { useAuth } from '@/Components/Auth/Login/auth';
import ImagesFinder from '@/Components/ImagesFinder/ImagesFinder';
import drawerActions from '@/Actions/drawer.actions';
import GlobalSearch from '@/Components/globalSearch/search';
import { Button } from '@/Components/ui/button';
import moment from 'moment';

const options = [
	{
		label: 'Product Name',
		value: 'productName',
		placeholder: 'Search by Product Name',
	},
	{
		label: 'Order ID',
		value: 'orderId',
		placeholder: 'Search by Order ID',
	},
	{
		label: 'Item ID',
		value: 'itemId',
		placeholder: 'Search by Item ID',
	},
];

const dateTypeArr = [
	{
		label: 'Created At',
		value: 'createdAt',
	},
	{
		label: 'Scheduled At',
		value: 'scheduledAt',
	},
	{
		label: 'Plan Date',
		value: 'planDate',
	}
];

const CookingHistoryListData = (props) => {
	const {
		data,
		resetInventoryAnalyticsState,
		productsList,
	} = props;

	const { appConfig = {} } = useAuth();
	const { combineCMSBatches } = appConfig?.configs ?? {};
	const [searchValue, setSearchValue] = useState({});
	const [filters, setFilters] = useState({});
	const useQueryParams = () => {
		const { search } = useLocation();
		return new URLSearchParams(search);
	};
	const params = useQueryParams();
	const rawName = params.get('name') || '';
	const cleanName = rawName.replace(/['"]+/g, '').trim();
	const flag = params.get('flag');
	const dispatch = useDispatch();

	const dataGenerator = useCallback(() => {
		const filteredData =
			data &&
			data
				?.map((ele) => {
					return {
						...ele,
						productName:
							productsList?.find((product) => product?.id === ele?.productId)?.productName ?? '-',
					};
				}).filter((ele) => {
					if (searchValue?.searchValue) {
						return (ele?.productName?.toLowerCase().trim().includes(searchValue?.searchValue?.toLowerCase().trim()) ||
							ele?.orderId?.toLowerCase().trim().includes(searchValue?.searchValue?.toLowerCase().trim()) ||
							ele?.itemId?.toLowerCase().trim().includes(searchValue?.searchValue?.toLowerCase().trim()));
					}
					return ele;
				});
		dispatch(analyticsAction.setQCSearchResults(
			searchValue?.searchValue,
			filteredData,
			searchValue?.value)
		);
		return filteredData;
	}, [data, productsList, searchValue?.searchValue]);

	const filtersInfo = {
		header: {
			store: false,
			date: false,
			product: false,
			process: false,
		},
		productWithVariants: {
			show: true,
			text: 'Search Products',
		},
		kitchenBaseStore: {
			show: true,
			text: 'Kitchen',
		},
		...(combineCMSBatches ? {
			pods: {
				show: true,
				text: 'Pods',
			},
		} : {}),
		dateRangeWithType: {
			text: 'Execution Time',
			show: true,
		},
		timeType: {
			text: 'Date Time Type',
			show: true,
		},
		skuType: {
			show: true,
			text: 'Select SKU Type',
			multiSelect: true,
		},
		allProcessType: {
			show: true,
			multiSelect: true,
		},
		...(combineCMSBatches ? {
			mealType: {
				show: true,
				singleSelect: true,
			},
		} : {}),
	};

	const exportInfo = {
		showExportBtn: true,
	};

	useEffect(() => {
		if (!flag) {
			dispatch(drawerActions.toggleFiltersDrawer(true));
		}
		return () => {
			resetInventoryAnalyticsState({
				entity: 'COOKING_ANALYTICS', method: 'LIST_DATA', data: [],
			});
		}
	}, []);

	const fetchCookingHistory = (filtersValue) => {
		setFilters(filtersValue);
		const req = {
			data: {
				dateRangeFilter: { from: moment(filtersValue?.dateRange?.from).format('YYYY-MM-DD'), to: moment(filtersValue?.dateRange?.to).format('YYYY-MM-DD') },
				timeType: filtersValue?.timeType?.value,
				processTypes: filtersValue?.allProcessTypeMulti?.id,
				skuTypes: filtersValue?.skuTypeMulti,
				storeId: filtersValue?.toPodFilter?.id,
				fromStore: filtersValue?.fromPodFilter?.id,
				mealType: filtersValue?.mealType,
				variantIds: [...new Set(filtersValue?.productWithVariant?.productData?.flatMap(item => item?.variantIds) || [])],
			}
		}
		dispatch(
			analyticsAction?.gateway({
				entity: 'COOKING_ANALYTICS',
				req,
				method: 'LIST_DATA',
			})
		);
	}


	return (
		<div className={styles.root}>
			<ImagesFinder
				filtersInfo={filtersInfo}
				exportInfo={exportInfo}
				onSubmit={fetchCookingHistory}
				avoidInitialCall={!flag}
				timeTypeArray={dateTypeArr}
			/>
			<div
				className='flex flex-1 items-baseline gap-3'
			>
				<div className='flex-1 min-w-0'>
					<GlobalSearch
						dropDownOptions={options}
						setSelectedValue={setSearchValue}
						initialValue={cleanName}
					/>
				</div>
				<Button
					onClick={(e) => {
						dispatch(drawerActions.toggleFiltersDrawer(true, {
							handleDataExport: (filters) => {
								const exportReq = {
									dateRangeFilter: { from: moment(filters?.dateRange?.from).format('YYYY-MM-DD'), to: moment(filters?.dateRange?.to).format('YYYY-MM-DD') },
									timeType: filters?.timeType?.value,
									processTypes: filters?.allProcessTypeMulti?.id,
									skuTypes: filters?.skuTypeMulti,
									storeId: filters?.toPodFilter?.id,
									fromStore: filters?.fromPodFilter?.id,
									mealType: filters?.mealType,
									variantIds: [...new Set(filters?.productWithVariant?.productData?.flatMap(item => item?.variantIds) || [])],
								}
								dispatch(analyticsAction?.exportAiCookingAnalytics(exportReq));
							}
						}));
					}}
					className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
				>
					<span className='text-nowrap'>Filter & Export</span>
					<Filter className='size-4' />
				</Button>
			</div>
			{filtersInfoChip(filtersInfo, filters)}
			<CookingAnalysisListPage
				data={dataGenerator()}
			/>
		</div>
	);
};

CookingHistoryListData.defaultProps = {};

const mapStateToProps = (state) => {
	const { LIST_DATA: data } = state.analytics?.COOKING_ANALYTICS;
	const productsList = state.form?.ALL_PRODUCTS?.data?.LIST;
	return {
		data: data?.recipes,
		productsList,
	};
};

const mapDispatchToProps = {
	resetInventoryAnalyticsState: analyticsAction.resetInventoryAnalyticsState,
};
export default connect(mapStateToProps, mapDispatchToProps)(CookingHistoryListData);
